import { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";

import exifr from "exifr";
import heic2any from "heic2any";

import { header, host } from "./globalVariables";
import { api } from "./pureFunctions";

import { degrees, PDFDocument, rgb, StandardFonts } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { Alert, Spinner } from "react-bootstrap";
import CurrencyInput from "react-currency-input-field";
import { oOEstateData } from "./globalVariables";
import { useConfig } from "./ConfigContext";

function Bewertungsmappe({}) {
   const config = useConfig();
   async function readPDFPages(url) {
      const PdfBytes = await fetch(host + url).then((data) => data.arrayBuffer());
      const pdfDoc = await PDFDocument.load(PdfBytes);
      return pdfDoc;
   }

   async function readInputPDF(file) {
      let pdffile = false;
      if (file) {
         const filearraybuffer = await file.arrayBuffer();
         pdffile = await PDFDocument.load(filearraybuffer);
      }
      return pdffile;
   }

   async function mergePages(resultFile, addFile) {
      const copiedPagesB = await resultFile.copyPages(addFile, addFile.getPageIndices());
      copiedPagesB.forEach((page) => resultFile.addPage(page));
   }

   async function generatePDF(bewertungsdaten) {
      setProcessing("loading");

      const pdfDoc = await readPDFPages("/PDFVorlagen/00_Bewertungsmappe_Start.pdf");

      const pdfImmowertanalyse = await readPDFPages("/PDFVorlagen/021_Bewertungsmappe_Immowertanalyse.pdf");
      const pdfSachwert = await readPDFPages("/PDFVorlagen/02_Bewertungsmappe_Sachwert.pdf");
      const pdfVergleichswert = await readPDFPages("/PDFVorlagen/04_Bewertungsmappe_Vergleichswert.pdf");
      const pdfObjstandanalyse = await readPDFPages("/PDFVorlagen/06_Bewertungsmappe_ObjStandAnalyse.pdf");
      const pdfBodenrichtwert = await readPDFPages("/PDFVorlagen/08_Bewertungsmappe_Bodenrichtwert.pdf");
      const pdfBaurFamilie = await readPDFPages("/PDFVorlagen/10_Bewertungsmappe_FamilieBaur.pdf");
      const pdfKarte = await readPDFPages("/PDFVorlagen/11_Bewertungsmappe_Karte.pdf");
      const pdfNotizen = await readPDFPages("/PDFVorlagen/99_Bewertungsmappe_Notizen.pdf");

      const pdfindex = await readInputPDF(bewertungsdaten.index);
      const pdfsprengnetter = await readInputPDF(bewertungsdaten.sprengnetter);
      const pdfreport = await readInputPDF(bewertungsdaten.report);
      const pdfboris = await readInputPDF(bewertungsdaten.boris);
      const pdfmaps = await readInputPDF(bewertungsdaten.maps);

      let pdftitelbildjpeg = false;
      let pdftitelbildpng = false;
      const titellupearray = await fetch(host + "/PDFVorlagen/Lupe_crop.png").then((data) => data.arrayBuffer());
      const pdftitellupe = await pdfDoc.embedPng(titellupearray);

      console.log(bewertungsdaten.titelbild);
      let titelbildrotation = false;

      if (bewertungsdaten.titelbild) {
         // pdftitelbildjpeg = await bewertungsdaten.titelbild.arrayBuffer();
         console.log(bewertungsdaten.titelbild);
         titelbildrotation = await exifr.rotation(bewertungsdaten.titelbild);

         if (bewertungsdaten.titelbild.type === "image/jpeg") {
            pdftitelbildjpeg = await bewertungsdaten.titelbild.arrayBuffer();
         } else if (bewertungsdaten.titelbild.type === "image/png") {
            pdftitelbildpng = await bewertungsdaten.titelbild.arrayBuffer();
         } else {
            const convertedFile = await heic2any({
               blob: bewertungsdaten.titelbild,
               toType: "image/jpeg", // oder "image/png"
               quality: 0.6, // nur relevant für jpeg
            });
            pdftitelbildjpeg = await convertedFile.arrayBuffer();
         }
      } else {
         pdftitelbildjpeg = await fetch(host + "/PDFVorlagen/Bewertungsmappe_Titelbild_sm.jpeg").then((data) =>
            data.arrayBuffer(),
         );
      }

      // const pdfImage = await pdfDoc.embedJpg(pdftitelbildjpeg);

      const pdfImage = pdftitelbildjpeg
         ? await pdfDoc.embedJpg(pdftitelbildjpeg)
         : await pdfDoc.embedPng(pdftitelbildpng);

      //----------MERGING-----------------------------

      pdfindex ? await mergePages(pdfDoc, pdfindex) : await mergePages(pdfDoc, pdfNotizen);

      // console.log(pdfDoc.getPageIndices().length);
      console.log(pdfsprengnetter);

      await mergePages(pdfDoc, pdfImmowertanalyse);

      if (pdfsprengnetter) {
         await mergePages(pdfDoc, pdfSachwert);
         await mergePages(pdfDoc, pdfsprengnetter);
      } else {
         console.log("Kein Sprengnetter");
      }

      if (pdfreport) {
         if (!(pdfDoc.getPageIndices().length % 2)) {
            await mergePages(pdfDoc, pdfNotizen);
         }
         await mergePages(pdfDoc, pdfVergleichswert);
         await mergePages(pdfDoc, pdfreport);
      } else {
         console.log("Kein Report");
      }

      if (pdfmaps) {
         if (!(pdfDoc.getPageIndices().length % 2)) {
            await mergePages(pdfDoc, pdfNotizen);
         }
         await mergePages(pdfDoc, pdfObjstandanalyse);
         await mergePages(pdfDoc, pdfmaps);
      } else {
         console.log("Kein Maps");
      }
      if (pdfboris) {
         if (!(pdfDoc.getPageIndices().length % 2)) {
            await mergePages(pdfDoc, pdfNotizen);
         }
         await mergePages(pdfDoc, pdfBodenrichtwert);
         await mergePages(pdfDoc, pdfboris);
      } else {
         console.log("Kein Boris");
      }
      if ((pdfDoc.getPageIndices().length + 3) % 4) {
         await mergePages(pdfDoc, pdfNotizen);
      }
      if ((pdfDoc.getPageIndices().length + 3) % 4) {
         await mergePages(pdfDoc, pdfNotizen);
      }
      if ((pdfDoc.getPageIndices().length + 3) % 4) {
         await mergePages(pdfDoc, pdfNotizen);
      }
      await mergePages(pdfDoc, pdfBaurFamilie);
      await mergePages(pdfDoc, pdfKarte);

      pdfDoc.registerFontkit(fontkit);
      const ralewayBoldFontBytes = await fetch(host + "/Fonts/Raleway-Bold.ttf").then((res) => res.arrayBuffer());
      const ralewayRegularFontBytes = await fetch(host + "/Fonts/Raleway-Regular.ttf").then((res) => res.arrayBuffer());
      const ralewayBoldFont = await pdfDoc.embedFont(ralewayBoldFontBytes);
      const ralewayRegularFont = await pdfDoc.embedFont(ralewayRegularFontBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      // const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)

      // Get the width and height of the first page
      const { width, height } = firstPage.getSize();
      console.log(width + " " + height);
      console.log(titelbildrotation.deg);

      if (titelbildrotation && titelbildrotation.deg === 180) {
         firstPage.drawImage(pdfImage, {
            x: width, //pdfImage.width, //firstPage.getWidth() / 2 - pdfImage.width / 2,
            y: height - 285, //firstPage.getHeight() / 2 - pdfImage.height / 2,
            width: width, //pdfImage.width,
            height: (width / pdfImage.width) * pdfImage.height,
            rotate: degrees(180),
         });
      } else {
         firstPage.drawImage(pdfImage, {
            x: 0, //firstPage.getWidth() / 2 - pdfImage.width / 2,
            y: height - 765, //firstPage.getHeight() / 2 - pdfImage.height / 2,
            width: width, //pdfImage.width,
            height: (width / pdfImage.width) * pdfImage.height,
         });
      }

      firstPage.drawImage(pdftitellupe, {
         x: 0, //firstPage.getWidth() / 2 - pdfImage.width / 2,
         y: height - 765, //firstPage.getHeight() / 2 - pdfImage.height / 2,
         width: width, //pdfImage.width,
         height: (width / pdftitellupe.width) * pdftitellupe.height,
      });

      // Draw a string of text diagonally across the first page
      /*     firstPage.drawText(bewertungsdaten.name, {
      x: 56.69309997558594,
      y: height - 252.02716064453125,
      size: 19,
      font: ralewayRegularFont,
      color: rgb(0, 0, 0),
    });
    firstPage.drawText(bewertungsdaten.strasse, {
      x: 56.69309997558594,
      y: height - 206.42718505859375,
      size: 19,
      font: ralewayRegularFont,
      color: rgb(0, 0, 0),
    });
    firstPage.drawText(bewertungsdaten.ort, {
      x: 56.69309997558594,
      y: height - 229.2271728515625,
      size: 19,
      font: ralewayRegularFont,
      color: rgb(0, 0, 0),
    }); */

      firstPage.drawText(bewertungsdaten.strasse + ", " + bewertungsdaten.ort, {
         x: 56.69309997558594,
         y: height - 206.42718505859375,
         size: 19,
         font: ralewayRegularFont,
         color: rgb(0, 0, 0),
      });
      firstPage.drawText("Eigentümer/in: " + bewertungsdaten.name, {
         x: 56.69309997558594,
         y: height - 229.2271728515625,
         size: 19,
         font: ralewayRegularFont,
         color: rgb(0, 0, 0),
      });
      firstPage.drawText("Ansprechpartner/in: " + bewertungsdaten.benutzer, {
         x: 56.69309997558594,
         y: height - 252.02716064453125,
         size: 19,
         font: ralewayRegularFont,
         color: rgb(0, 0, 0),
      });
      pages[4].drawText(bewertungsdaten.notizen, {
         x: 77.89199829101562,
         y: height - 677.4815673828125,
         size: 10,
         font: ralewayRegularFont,
         color: rgb(0, 0, 0),
         maxWidth: width - 2 * 77.89199829101562,
         lineHeight: 14,
      });

      pages[4].drawText(
         (parseFloat(bewertungsdaten.marktwertentwicklung.replace(/\./g, "").replace(",", ".")) > 0 ? "+" : "") +
            bewertungsdaten.marktwertentwicklung +
            " %",
         {
            x: 404.79180908203125,
            y: height - 222.91290283203125,
            size: 10,
            font: ralewayBoldFont,
            color: rgb(0, 0, 0),
         },
      );
      pages[4].drawText(
         new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
         }).format(bewertungsdaten.minpreiserwartung) + "/m²",
         {
            x: 404.79180908203125,
            y: height - 253.492919921875,
            size: 10,
            font: ralewayBoldFont,
            color: rgb(0, 0, 0),
         },
      );
      pages[4].drawText(
         new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
         }).format(bewertungsdaten.maxpreiserwartung) + "/m²",
         {
            x: 404.79180908203125,
            y: height - 284.42291259765625,
            size: 10,
            font: ralewayBoldFont,
            color: rgb(0, 0, 0),
         },
      );
      pages[4].drawText(
         "Stand " +
            new Date().toLocaleDateString("de-DE", {
               year: "numeric",
               month: "long" /* , day: 'numeric'  */,
            }),
         {
            x: 252.2171936035156,
            y: height - 378.61285400390625,
            size: 10,
            font: ralewayRegularFont,
            color: rgb(0, 0, 0),
         },
      );
      pages[4].drawText(
         new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
         }).format(bewertungsdaten.minwert),
         {
            x: 112.0011978149414,
            y: height - 512.7760620117188,
            size: 10,
            font: ralewayBoldFont,
            color: rgb(0, 0, 0),
         },
      );
      pages[4].drawText(
         new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
         }).format(bewertungsdaten.maxwert),
         {
            x: 454.14520263671875,
            y: height - 512.7760620117188,
            size: 10,
            font: ralewayBoldFont,
            color: rgb(0, 0, 0),
         },
      );

      // Serialize the PDFDocument to bytes (a Uint8Array)
      const pdfBytes = await pdfDoc.save();

      const blob = new Blob([pdfBytes], { type: "application/pdf" });

      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = "Bewertungsmappe_" + bewertungsdaten.name + ".pdf";
      a.click();
      window.URL.revokeObjectURL(url);

      setProcessing(false);
   }

   const [estateId, setEstateId] = useState();
   const [sharepoint, setSharepoint] = useState();
   const [processing, setProcessing] = useState();
   const [bewertungsdaten, setBewertungsdaten] = useState({
      name: "",
      strasse: "",
      ort: "",
      marktwertentwicklung: "",
      minpreiserwartung: "",
      maxpreiserwartung: "",
      minwert: "",
      maxwert: "",
      notizen: "",
      eigenanrede: "",
      eigenname: "",
      makleranrede: "",
      benutzer: "",
   });

   useEffect(() => {
      let params = new URLSearchParams(document.location.search);
      const url_id = params.get("estateid");
      setEstateId(url_id);
      console.log(url_id);
      if (url_id) {
         getData(url_id);
      }
   }, []);

   async function getData(url_id) {
      const newdata = {};
      const userlist = await api.get("/api/getusers").then((data) => {
         console.log(data.data);
         return data.data.data;
      });
      // const jsondatafieldname = "ind_2998_Feld_ObjIndividualCategoryFields412";
      const oo_fieldname_array = ["strasse", "hausnummer", "plz", "ort", "benutzer", config.estate.ordnerName];

      await api
         .post("/api/readSelectedEstate", [{ id: url_id, oOEstateData, oo_fieldname_array }], header)
         .then((data) => {
            console.log(data.data);
            setSharepoint({ foldername: data.data[config.estate.ordnerName] });
            if (data.data[oOEstateData]) {
               const jsondata = JSON.parse(data.data[oOEstateData]);
               console.log(jsondata);
               let makler = userlist.find((item) => data.data.benutzer === item.elements.id);
               console.log(makler);

               setBewertungsdaten((old) => {
                  const updated = { ...old };
                  updated.benutzer = makler ? makler.elements.Vorname + " " + makler.elements.Nachname : "";
                  updated.strasse = data.data.strasse + " " + data.data.hausnummer;
                  updated.ort = data.data.plz + " " + data.data.ort;

                  updated.marktwertentwicklung = jsondata.bb_mwe;
                  updated.minpreiserwartung = jsondata.bb_minpe;
                  updated.maxpreiserwartung = jsondata.bb_maxpe;
                  updated.minwert = jsondata.bb_minw;
                  updated.maxwert = jsondata.bb_maxw;
                  updated.notizen = jsondata.bb_note;
                  return updated;
               });
            } else {
               setBewertungsdaten((old) => {
                  const updated = { ...old };
                  updated.strasse = data.data.strasse + " " + data.data.hausnummer;
                  updated.ort = data.data.plz + " " + data.data.ort;
                  return updated;
               });
            }
         });

      const ownerId = await api.post("/api/postEstateOwnerId", [url_id], header).then((data) => {
         const newownerId = Object.values(data.data)[0][0];
         console.log(newownerId);
         return newownerId;
      });

      await api
         .post(
            "/api/postSpecificAddress",
            { id: ownerId, data: ["Vorname", "Name", "KdNr" /* , "Benutzer" */] },
            header,
         )
         .then((data) => {
            console.log(data.data);
            // let makler = userlist.find((item) => data.data.Benutzer === item.elements.Name);

            setBewertungsdaten((old) => {
               const updated = { ...old };
               updated.name = data.data.Vorname + " " + data.data.Name;
               // updated.benutzer = makler.elements.Vorname + " " + makler.elements.Nachname;
               return updated;
            });
         });
   }

   async function updateBewertungsdaten(e, type) {
      console.log(bewertungsdaten);
      console.log(e);
      /* if (type === "file") {
         let num = await exifr.rotation(e.target.files[0]);
         console.log(num);
      } */
      setBewertungsdaten((old) => {
         const updated = { ...old };
         if (type === "single") updated[e.target.name] = e.target.value;
         if (type === "file") {
            updated[e.target.name] = e.target.files[0];
         }
         return updated;
      });
   }

   return (
      <div className="p-5">
         <title>BM erstellen</title>
         <h1>Bewertungsmappe erstellen</h1>
         {sharepoint && (
            <a
               href={config.ms365.sharepointUrl+"/Immobilien/" + sharepoint.foldername}
               style={{
                  display: "inline-block",
                  padding: "10px 24px",
                  marginRight: "4px",
                  textDecoration: "none",
                  border: "0px solid #ddd",
                  color: "white",
                  backgroundColor: "#45f",
                  borderRadius: "8px",
               }}
               target="_blank"
            >
               Ordner <strong> {sharepoint.foldername}</strong> ↗
            </a>
         )}
         <a
            href={"/datenblatt?estateid=" + estateId}
            target="_blank"
            style={{
               display: "inline-block",
               padding: "10px 24px",
               marginBottom: "4px",
               textDecoration: "none",
               border: "0px solid #ddd",
               color: "white",
               backgroundColor: "#45f",
               borderRadius: "8px",
            }}
         >
            {" "}
            Zum Objekt ↗
         </a>
         <Form>
            <Alert>
               <h5>Info: </h5>
               {/* - Einheiten und Tausender-Punkt werden beim Erstellen automatisch eingesetzt<br/> */}- Wenn kein
               Immobilienfoto vorhanden ist, kann das Feld frei bleiben und das Standardbild wird automatisch eingefügt
            </Alert>

            <Form.Group className="mb-3" controlId="formGridAddress1">
               <Form.Label>Name</Form.Label>
               <Form.Control
                  autoComplete="off"
                  value={bewertungsdaten.name}
                  onChange={(e) => updateBewertungsdaten(e, "single")}
                  name="name"
               />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formGridAddress2">
               <Form.Label>Strasse und Hausnummer</Form.Label>
               <Form.Control
                  autoComplete="off"
                  value={bewertungsdaten.strasse}
                  onChange={(e) => updateBewertungsdaten(e, "single")}
                  name="strasse"
               />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formGridAddress3">
               <Form.Label>Stadt</Form.Label>
               <Form.Control
                  autoComplete="off"
                  onChange={(e) => updateBewertungsdaten(e, "single")}
                  name="ort"
                  value={bewertungsdaten.ort}
               />
            </Form.Group>

            {/*<Row className="mb-3">
          <Form.Group as={Col} controlId="formGrideigenanrede">
            <Form.Label>Eigentümer/in (Anrede)</Form.Label>
            <Form.Select
              onChange={(e) => updateBewertungsdaten(e, "single")}
              name="eigenanrede"
              value={bewertungsdaten.eigenanrede}
            >
              <option></option>
              <option value="Eigent">eigenpartnerin</option>
              <option value="eigenpartner">eigenpartner</option>
            </Form.Select>
          </Form.Group> 

          <Form.Group as={Col} controlId="formGrideigenname">
            <Form.Label>Eigentümer/in</Form.Label>
            <Form.Control
              onChange={(e) => updateBewertungsdaten(e, "single")}
              name="eigenname"
              value={bewertungsdaten.eigenname}
            />
          </Form.Group>
        </Row>*/}

            <Row className="mb-3">
               {/* <Form.Group as={Col} controlId="formGridmakleranrede">
            <Form.Label>Makler/in (Anrede)</Form.Label>
            <Form.Select
              onChange={(e) => updateBewertungsdaten(e, "single")}
              name="makleranrede"
              value={bewertungsdaten.makleranrede}
            >
              <option></option>
              <option value="Maklerin">Maklerin</option>
              <option value="Makler">Makler</option>
            </Form.Select>
          </Form.Group> */}

               <Form.Group as={Col} controlId="formGridmaklername">
                  <Form.Label>Ansprechpartner/in</Form.Label>
                  <Form.Control
                     autoComplete="off"
                     onChange={(e) => updateBewertungsdaten(e, "single")}
                     name="benutzer"
                     value={bewertungsdaten.benutzer}
                  />
               </Form.Group>
            </Row>

            <Form.Group className="mb-3" controlId="formGridMarktwertentwicklung">
               <Form.Label>Marktwertentwicklung [%]</Form.Label>
               <Form.Control
                  autoComplete="off"
                  placeholder=""
                  onChange={(e) => updateBewertungsdaten(e, "single")}
                  name="marktwertentwicklung"
                  value={bewertungsdaten.marktwertentwicklung}
               />
            </Form.Group>

            <Row className="mb-3">
               <Form.Group as={Col} controlId="formGridminPreis">
                  <Form.Label>Minimum Preiserwartung [€/m²]</Form.Label>
                  <CurrencyInput
                     autoComplete="off"
                     className={"currency-input"}
                     name="minpreiserwartung"
                     value={bewertungsdaten.minpreiserwartung}
                     placeholder="---"
                     allowNegativeValue={false}
                     decimalsLimit={2}
                     suffix=""
                     decimalSeparator=","
                     groupSeparator="."
                     onValueChange={(value, name, values) =>
                        updateBewertungsdaten({ ["target"]: { ["name"]: name, ["value"]: value } }, "single")
                     }
                  />

                  {/* <Form.Control
                     onChange={(e) => updateBewertungsdaten(e, "single")}
                     name="minpreiserwartung"
                     value={bewertungsdaten.minpreiserwartung}
                  /> */}
               </Form.Group>

               <Form.Group as={Col} controlId="formGridmaxpreis">
                  <Form.Label>Maximum Preiserwartung [€/m²]</Form.Label>
                  <CurrencyInput
                     autoComplete="off"
                     className={"currency-input"}
                     name="maxpreiserwartung"
                     value={bewertungsdaten.maxpreiserwartung}
                     placeholder="---"
                     allowNegativeValue={false}
                     decimalsLimit={2}
                     suffix=""
                     decimalSeparator=","
                     groupSeparator="."
                     onValueChange={(value, name, values) =>
                        updateBewertungsdaten({ ["target"]: { ["name"]: name, ["value"]: value } }, "single")
                     }
                  />
                  {/* 
                  <Form.Control
                     onChange={(e) => updateBewertungsdaten(e, "single")}
                     name="maxpreiserwartung"
                     value={bewertungsdaten.maxpreiserwartung}
                  /> */}
               </Form.Group>
            </Row>

            <Row className="mb-3">
               <Form.Group title="Tausender Punkt wird nicht automatisch gesetzt." as={Col} controlId="formGridminWert">
                  <Form.Label>Minimum Wert [€]</Form.Label>
                  <CurrencyInput
                     autoComplete="off"
                     className={"currency-input"}
                     name="minwert"
                     value={bewertungsdaten.minwert}
                     placeholder="---"
                     allowNegativeValue={false}
                     decimalsLimit={2}
                     suffix=""
                     decimalSeparator=","
                     groupSeparator="."
                     onValueChange={(value, name, values) =>
                        updateBewertungsdaten({ ["target"]: { ["name"]: name, ["value"]: value } }, "single")
                     }
                  />
               </Form.Group>

               <Form.Group title="Tausender Punkt wird nicht automatisch gesetzt." as={Col} controlId="formGridmaxWert">
                  <Form.Label>Maximum Wert [€]</Form.Label>
                  <CurrencyInput
                     autoComplete="off"
                     className={"currency-input"}
                     name="maxwert"
                     value={bewertungsdaten.maxwert}
                     placeholder="---"
                     allowNegativeValue={false}
                     decimalsLimit={2}
                     suffix=""
                     decimalSeparator=","
                     groupSeparator="."
                     onValueChange={(value, name, values) =>
                        updateBewertungsdaten({ ["target"]: { ["name"]: name, ["value"]: value } }, "single")
                     }
                  />
               </Form.Group>
            </Row>

            <Form.Group className="mb-3" controlId="formGridNotizen">
               <Form.Label>Notizen</Form.Label>
               <Form.Control
                  autoComplete="off"
                  as="textarea"
                  onChange={(e) => updateBewertungsdaten(e, "single")}
                  name="notizen"
                  value={bewertungsdaten.notizen}
               />
            </Form.Group>

            <Row>
               <Form.Label column lg={3}>
                  Titelbild [.jpeg/.png/.heif/.heic]
               </Form.Label>
               <Col>
                  <Form.Control
                     type="file"
                     name="titelbild"
                     accept="image/jpeg, image/png, image/heif, image/heic"
                     onChange={(e) => updateBewertungsdaten(e, "file")}
                  />
               </Col>
               <Form.Text id="passwordHelpBlock" muted>
                  Wenn kein Foto vorhanden ist, wird automatisch das Standardbild eingefügt.
               </Form.Text>
            </Row>
            <br />

            <Row>
               <Form.Label column lg={3}>
                  Index
               </Form.Label>
               <Col>
                  <Form.Control
                     type="file"
                     name="index"
                     accept="application/pdf"
                     onChange={(e) => updateBewertungsdaten(e, "file")} /* multiple */
                  />
               </Col>
            </Row>
            <br />
            <Row>
               <Form.Label column lg={3}>
                  Sprengnetter
               </Form.Label>
               <Col>
                  <Form.Control
                     type="file"
                     name="sprengnetter"
                     accept="application/pdf"
                     onChange={(e) => updateBewertungsdaten(e, "file")}
                  />
               </Col>
            </Row>
            <br />

            <Row>
               <Form.Label column lg={3}>
                  Report
               </Form.Label>
               <Col>
                  <Form.Control
                     type="file"
                     name="report"
                     accept="application/pdf"
                     onChange={(e) => updateBewertungsdaten(e, "file")}
                  />
               </Col>
            </Row>
            <br />

            <Row>
               <Form.Label column lg={3}>
                  Boris
               </Form.Label>
               <Col>
                  <Form.Control
                     type="file"
                     name="boris"
                     accept="application/pdf"
                     onChange={(e) => updateBewertungsdaten(e, "file")}
                  />
               </Col>
            </Row>
            <br />
            <Row>
               <Form.Label column lg={3}>
                  Maps
               </Form.Label>
               <Col>
                  <Form.Control
                     type="file"
                     lg={3}
                     name="maps"
                     accept="application/pdf"
                     onChange={(e) => updateBewertungsdaten(e, "file")}
                  />
               </Col>
            </Row>
            <br />

            <Button
               variant="dark"
               disabled={processing === "loading"}
               className={"me-2" + (processing === "loading" ? " button-loader" : "")}
               onClick={() => generatePDF(bewertungsdaten)}
            >
               PDF generieren
            </Button>
            <a
               target="_blank"
               className="btn btn-outline-primary me-2"
               rel="noopener noreferrer"
               href="https://tools.pdf24.org/de/pdf-komprimieren"
            >
               ↗ PDF komprimieren
            </a>
         </Form>
      </div>
   );
}

export default Bewertungsmappe;
